export default __webpack_public_path__ + "static/media/screen1.9ddff36e.svg";